<div class="shortcut-container">
  <div class="shortcut-header">
    <div class="shortcut-header-title" *ngFor="let header of this.hotLink.header">
      {{header}}</div>
  </div>
  <div class="shortcut-link-container">
    <div *ngFor="let link of this.hotLink.links" class="shortcut-links">
      <ng-container
        [ngTemplateOutlet]="isDisabled(link) ? disabledLink :  activeLink"
        [ngTemplateOutletContext]="{link:link}">
      </ng-container>
    </div>
  </div>
  <div class="shortcut-resources">
    <div class="resource-item">
      <a href="{{this.hotLink.accessRequest.url}}" target="_blank" rel="noopener noreferrer">
        {{this.hotLink.accessRequest.label}}
      </a>
    </div>
    <!--    <div class="resource-item">-->
    <!--      <a href="{{this.hotLink.viewDashboard.url}}">-->
    <!--        {{this.hotLink.viewDashboard.label}}-->
    <!--      </a>-->
    <!--    </div>-->
  </div>
</div>

<ng-template #activeLink let-link='link'>
  <a href="{{link.url}}">
    {{link.label}}
  </a>
</ng-template>

<ng-template #disabledLink let-link='link'>
  <p class="disabled-link">{{link.label}}</p>
</ng-template>
